import { $getNodeByKey, $isRootNode, $isTextNode, LexicalNode } from 'lexical';
import { removeZeroWidthSpace } from 'utils/chars';
import { $isNoWrapNode } from './NoWrapNode';

const isBlankText = (node: LexicalNode): boolean => {
  if (!$isTextNode(node)) {
    return false;
  }
  const text = node.getTextContent();

  return !text || removeZeroWidthSpace(text.trim()).length === 0;
};

const isEmptyNoWrapNode = (node: LexicalNode): boolean => {
  if (!$isNoWrapNode(node) || !node.isAttached()) {
    return false;
  }

  const children = node.getChildren();

  return children.length === 0 || children.every(isBlankText);
};

export function $removeEmptyNoWrapNodesByKeys(nodeKeys: Set<string>): void {
  const processNodeAndAncestors = (startNode: LexicalNode): void => {
    let current: LexicalNode | null = startNode;

    while (current && !$isRootNode(current)) {
      const parent = current.getParent();

      if (isEmptyNoWrapNode(current)) {
        current.remove();
        current = parent;
      } else {
        current = parent;
      }
    }
  };

  for (const nodeKey of nodeKeys) {
    const node = $getNodeByKey(nodeKey);
    if (node) {
      processNodeAndAncestors(node);
    }
  }
}
